import { Component, OnInit } from '@angular/core';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
	selector: 'disabled-virtual-binder',
	templateUrl: './disabled-virtual-binder.component.html',
	styleUrls: ['./disabled-virtual-binder.component.scss', '../../stylesheets/job-main.scss']
})
export class DisabledVirtualBinderComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
		setTimeout(() => {
			GlobalSettingsService.isGlobalLoaderLoading = false;
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}, 0);
	}

}
